import React, { FC, useEffect, useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { AppBar, Box, Grid, IconButton, Toolbar } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import MenuIcon from '@mui/icons-material/Menu'
import CloseIcon from '@mui/icons-material/Close'
import clsx from 'clsx'
import { Navigation } from '../Navigation'
import { routes } from '../../constants/routes'
import { ReactComponent as LogoImg } from '../../images/header/logo.svg'

const useStyles = makeStyles((theme: Theme) => ({
  appBar: {
    position: 'absolute',
    width: '100%',
    height: 176,
    background: 'none',
    boxShadow: 'none',
    padding: '0 20px',
  },
  appBarOpen: {
    boxShadow: 'none',
  },
  appBarClose: {
    background: theme.palette.secondary.dark,
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    maxWidth: 1184,
    width: '100%',
    height: '100%',
    margin: '0 auto',
    padding: 0,
    boxSizing: 'content-box',
  },
  menu: {
    display: 'flex',
    alignItems: 'center',
  },
  logo: {
    width: 166,
  },
  burgerButton: {
    padding: 0,
    marginLeft: 80,
    height: 'min-content',
  },
}))

export const Header: FC = () => {
  const { pathname } = useLocation()
  const [open, setOpen] = useState<boolean>(false)
  const classes = useStyles({ pathname })

  const handleClick = () => {
    setOpen(!open)
  }

  useEffect(() => {
    if (open) {
      setOpen(false)
    }
    // eslint-disable-next-line
  }, [pathname])

  return (
    <Grid container>
      <AppBar className={clsx(classes.appBar, !open ? classes.appBarOpen : classes.appBarClose)}>
        <Toolbar className={classes.toolbar}>
          <NavLink exact to={routes.HOME}>
            <LogoImg style={{ fill: pathname === '/' || open ? '#FFFFFF' : '#000000' }} className={classes.logo} />
          </NavLink>

          {pathname !== routes.TWO_FA_LOGIN && (
            <Box className={classes.menu}>
              {open && <Navigation />}

              <IconButton onClick={handleClick} color="inherit" aria-label="menu" className={classes.burgerButton}>
                {!open ? (
                  <MenuIcon
                    style={{
                      color: pathname !== routes.PRIVACY_POLICY && pathname !== routes.LOGIN ? 'white' : 'black',
                    }}
                  />
                ) : (
                  <CloseIcon />
                )}
              </IconButton>
            </Box>
          )}
        </Toolbar>
      </AppBar>
    </Grid>
  )
}
